"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataBuilder = void 0;
var constants_1 = require("../utils/constants");
function metadataBuilder(settings) {
    return {
        s: settings.version,
        i: settings.runtime.ip || constants_1.UNKNOWN,
        n: settings.runtime.hostname || constants_1.UNKNOWN,
    };
}
exports.metadataBuilder = metadataBuilder;
